import { CHANGE_KEY } from "../Actions/actionTypes";

const initialState = {
  keys: [
    "AIzaSyDTg7b_WMvdhhZcFMqzOfRm4zemWZ-nzaQ",
    "AIzaSyDXiaS0MwmQksRSViC0uv889NDpE0t22w8",
    "AIzaSyD5N6MjwVqpRzJWOJ3wcAr7yqBeWb5vbpg"
  ],
  currentKey: 0
};

export const keyReducer = (state = initialState, action) => {
  if (action.type === CHANGE_KEY) {
    return state.currentKey === state.keys.length - 1
      ? { ...state, currentKey: 0 }
      : { ...state, currentKey: ++state.currentKey };
  }
  return { ...state };
};
